import { BinType } from 'commons/enums';
import { IBin, ProductDetail, STOItem } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';
import {
  ISTOPickedItemRequest,
  ISTOPickRemoveBatchRequest,
  ISTOProductDetailRequest,
} from '../SwipeRxWmsApiStoPickItem/types';

import { ISTOCompleteReceiveItem, STOReceiveItemRequest } from './type';
import { STOReceiveItemAssignByBoxPalletRequest } from './type/sto-receive-assign-remove-by-box-request.type';

class SwipeRxWmsApiStoReceiveItem extends SwipeRxWmsApi {
  constructor() {
    super(SwipeRxAPIResources.STO_RECEIVE_ITEM);
  }

  async getSTOReceiveList(): Promise<STOItem[]> {
    try {
      const result = await this.get(`${this.apiResource}/list`, undefined);
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getSTOReceiveItems(): Promise<STOItem[]> {
    try {
      const result = await this.get(`${this.apiResource}/assigned`, undefined);
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async assignSTOReceiveItem(): Promise<STOItem[]> {
    try {
      const result = await this.post(
        `${this.apiResource}/assign/new`,
        undefined,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async assignSTOReceiveItemByBoxPallet(
    payload: STOReceiveItemAssignByBoxPalletRequest,
  ): Promise<STOItem[]> {
    try {
      const result = await this.post(
        `${this.apiResource}/assign/new_box`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async addSTOReceiveItem(): Promise<STOItem> {
    try {
      const result = await this.post(
        `${this.apiResource}/assign/add`,
        undefined,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data[0];
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async startReceivingProcess(items: STOReceiveItemRequest[]): Promise<string> {
    try {
      const result = await this.post(`${this.apiResource}/start`, {
        items,
      });
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async removeSTOReceiveItem(payload: STOReceiveItemRequest) {
    try {
      const result = await this.patch(
        `${this.apiResource}/assign/remove`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async removeSTOReceiveItemByBoxPallet(
    payload: STOReceiveItemAssignByBoxPalletRequest,
  ) {
    try {
      const result = await this.patch(
        `${this.apiResource}/assign/remove_box`,
        payload,
      );
      if (!result.data) throw new Error('[FEError] Data not found');
      return result.data;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getBinRecommendationInfo(
    skuCode: string,
    binType: BinType,
  ): Promise<ProductDetail[]> {
    const result = await this.get(
      `${this.apiResource}/${skuCode}/bin-recommendation/${binType}/info`,
    );

    return result.data;
  }

  async postCompleteReceiving(params: ISTOCompleteReceiveItem): Promise<void> {
    await this.post(`${this.apiResource}/complete`, params);
  }

  async postReceiveItem(params: ISTOPickedItemRequest): Promise<boolean> {
    try {
      await this.post(`${this.apiResource}/receive-item`, params);
      return true;
    } catch (error) {
      return false;
    }
  }

  async postRemoveBatch(params: ISTOPickRemoveBatchRequest): Promise<void> {
    await this.post(`${this.apiResource}/remove-batch`, params);
  }

  async getProductDetail(params: ISTOProductDetailRequest): Promise<{
    error?: string | true;
    data?: IBin;
  }> {
    try {
      const result = await this.get(
        `${this.apiResource}/product-detail`,
        params,
      );
      const data = result.data as IBin;
      return { data };
    } catch (error: unknown) {
      if (error instanceof Error) {
        return { error: error.message };
      }
      return { error: true };
    }
  }
}

export const swipeRxWmsApiStoReceiveItem = new SwipeRxWmsApiStoReceiveItem();
